import { useCallback } from 'react';

import { useGetPresetPromptsForSimilarQuiz } from '@/api/ai/useGetPresetPromptsForSimilarQuiz';
import { useLocale } from '@/hooks';

import { useSelectSubject } from '../SectionBasicInfo/useSelectSubject';

export const usePromptPresets = ({ question }: { question: string }) => {
  const {
    mutateAsync: getPromptPresets,
    data,
    isSuccess,
  } = useGetPresetPromptsForSimilarQuiz();

  const { locale } = useLocale();
  const { subjectName } = useSelectSubject();

  const handleGetPromptPresets = useCallback(async () => {
    try {
      if (isSuccess) return;
      await getPromptPresets({
        locale,
        question,
        category: subjectName ?? '',
      });
    } catch (error) {
      console.warn(error);
    }
  }, [isSuccess, getPromptPresets, locale, question, subjectName]);

  return {
    handleGetPromptPresets,
    data,
  };
};
